/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Assigntome2Inputs */

const en_cases_assigntome2 = /** @type {(inputs: Cases_Assigntome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign to me`)
};

/**
* | output |
* | --- |
* | "Assign to me" |
*
* @param {Cases_Assigntome2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_assigntome2 = /** @type {((inputs?: Cases_Assigntome2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Assigntome2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_assigntome2(inputs)
});
export { cases_assigntome2 as "cases_assignToMe" }